import { render, staticRenderFns } from "./BuyerInPerson.vue?vue&type=template&id=1e624aa7&scoped=true&"
import script from "./BuyerInPerson.vue?vue&type=script&lang=js&"
export * from "./BuyerInPerson.vue?vue&type=script&lang=js&"
import style0 from "./BuyerInPerson.vue?vue&type=style&index=0&id=1e624aa7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e624aa7",
  null
  
)

export default component.exports